import { Button } from "src/components/MuiGenerals";
import { Params } from "src/features/common/types/GridRenderCellParams";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { useTranslation } from "src/hooks";
import { GetListRes } from "../types/GetListRes";
import { findChainInfo } from "src/utils/helper";
import { WalletSmartAccountType } from "@wallet-manager/node-types/dist/src/postgres/const";

const useOperationButton = () => {
  const { translatePrefix } = usePageConfigProviderContext();

  const { t } = useTranslation(translatePrefix);

  const renderOperationButtons = (params: Params<GetListRes>) => {
    const {
      chain_type,
      chain_id,
      asset_name,
      spender_address,
      major_wallet_version,
      smart_account_type,
    } = params?.row.rawData;
    const chainInfo = findChainInfo(String(chain_type), chain_id);
    const chainCode = chainInfo?.chain_code;
    const isSmartAccount =
      smart_account_type !== WalletSmartAccountType.EOA ? true : false;
    const walletMajorVersion = major_wallet_version.major_wallet_version;
    const handleOnClick = () => {
      window.open(
        `batchApproveAllowance?chainCode=${chainCode}&currency=${asset_name}&spenderAddress=${spender_address}&isSmartAccount=${isSmartAccount}&walletMajorVersion=${walletMajorVersion}`,
      );
    };

    return (
      <Button
        color="secondary"
        variant="contained"
        onClick={handleOnClick}
        children={t("preview")}
      />
    );
  };
  return { renderOperationButtons };
};
export default useOperationButton;
